import { Pipe, PipeTransform } from '@angular/core';

const STATUSES = {
  processing: $localize`Processing...`,
  complete: $localize`Complete`,
  failed: $localize`Failed`,
  partially_complete: $localize`Partially Complete`,
};

@Pipe({ name: 'fuelImportStatus' })
export class FuelImportStatusPipe implements PipeTransform {
  public transform(status) {
    return STATUSES[status];
  }
}
